import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {CrudActionTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudActionTypes';
import {canCreateAcquisitionList} from '@/components/acquisitionList/create/acquisitionListCreateAccess';

export type ShellCreateKey = 'institution' | 'student' | 'employee' | 'applicant' | 'training' | 'acquisitionList';

export type ShellCreateAction = {
    key: ShellCreateKey;
    text: string;
    icon: string;
};

type AccessManager = {
    canAccessType(type: CrudEntityTypes, action: CrudActionTypes): boolean;
    getAccess(type: CrudEntityTypes, action: CrudActionTypes): unknown;
};

/**
 * Global "Neu" menu of the app bar. Each entry opens the same dialog as the button on its overview page
 * and is only shown with the same rights.
 */
export const getShellCreateActions = (access: AccessManager): ShellCreateAction[] => {
    const can = (type: CrudEntityTypes, action: CrudActionTypes = CrudActionTypes.CREATE) => access.canAccessType(type, action);
    const actions: Array<ShellCreateAction & { allowed: boolean }> = [{
        key: 'institution',
        text: 'Standort',
        icon: 'mdi-domain',
        allowed: can(CrudEntityTypes.INSTITUTION),
    }, {
        key: 'student',
        text: 'Schüler:in',
        icon: 'mdi-school-outline',
        allowed: can(CrudEntityTypes.STUDENT),
    }, {
        key: 'employee',
        text: 'Mitarbeiter:in',
        icon: 'mdi-account-tie-outline',
        allowed: can(CrudEntityTypes.EMPLOYEE),
    }, {
        key: 'applicant',
        text: 'Bewerber:in',
        icon: 'mdi-account-search-outline',
        allowed: can(CrudEntityTypes.EMPLOYEE),
    }, {
        key: 'training',
        text: 'Schulung',
        icon: 'mdi-cast-education',
        allowed: !!access.getAccess(CrudEntityTypes.EVENT_INFO, CrudActionTypes.CREATE)
            && can(CrudEntityTypes.EVENT_TOPIC, CrudActionTypes.READ),
    }, {
        key: 'acquisitionList',
        text: 'Akquiseliste',
        icon: 'mdi-room-service-outline',
        allowed: canCreateAcquisitionList(),
    }];
    return actions.filter((el) => el.allowed).map(({key, text, icon}) => ({key, text, icon}));
};
